import React from 'react';
import Tippy from '@tippyjs/react/headless';
import Box from '@alucio/lux-ui/src/components/layout/Box/Box';
import findChildren from '@alucio/lux-ui/src/util/findChildren';
import PopoverCore from './PopoverCore';
// Lazily Mounted Tippy
// https://gist.github.com/atomiks/520f4b0c7b537202a23a3059d4eec908#gistcomment-3302321
export const LazyTippy = (props) => {
    const [mounted, setMounted] = React.useState(false);
    const lazyPlugin = {
        fn: () => ({
            onShow: () => setMounted(true),
            onHidden: () => setMounted(false),
        }),
    };
    const computedProps = { ...props };
    computedProps.plugins = [lazyPlugin, ...(props.plugins || [])];
    if (props.render) {
        const render = props.render; // let TypeScript safely derive that render is not undefined
        computedProps.render = (...args) => (mounted ? render(...args) : '');
    }
    else {
        computedProps.content = mounted ? props.content : '';
    }
    return <Tippy {...computedProps}/>;
};
const Popover = (props) => {
    const { children, visible, placement, interactive, onBackdropPress, lazyMount, } = props;
    const TippyType = lazyMount ? LazyTippy : Tippy;
    const [anchorChildren, , afterChildren] = findChildren(Popover.Anchor, children);
    const [contentChildren] = findChildren(Popover.Content, afterChildren);
    const contentProps = contentChildren?.[0]?.props ?? {};
    const ContentWrapper = (attrs) => (<Box {...attrs} style={[PopoverCore.Content.calculateStyle(props, contentProps), { zIndex: 100 }]}>
      {contentChildren}
    </Box>);
    return (<TippyType onClickOutside={onBackdropPress ?? (() => { })} interactive={interactive} visible={visible} placement={placement || 'bottom'} offset={[0, contentProps.offset ?? PopoverCore.DEFAULT_OFFSET]} render={ContentWrapper}>
      <div>
        {anchorChildren}
      </div>
    </TippyType>);
};
Popover.displayName = 'Popover';
Popover.defaultProps = {
    type: 'tooltip',
    lazyMount: false,
};
Popover.Anchor = PopoverCore.Anchor;
Popover.Content = PopoverCore.Content;
export default Popover;
//# sourceMappingURL=Popover.web.js.map